import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Tooltip } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import type { AddMemberDialogProps as Props } from './types';

export const AddMemberDialog = memo(
  ({ className, disabled, noAccess, onToggle }: Props) => {
    return (
      <Tooltip
        title={
          noAccess
            ? 'Access Denied: Only admins and owners can invite members.'
            : undefined
        }
        placement="left"
      >
        <span>
          <Styled.Wrapper
            className={classnames('AddMemberDialog', className)}
            variant="contained"
            color="primary"
            size="small"
            disabled={disabled || noAccess}
            onClick={onToggle}
            startIcon={<Icon name="plus" />}
          >
            Invite User
          </Styled.Wrapper>
        </span>
      </Tooltip>
    );
  }
);

AddMemberDialog.displayName = 'AddMemberDialog';
